import { NgModule } from '@angular/core';
import { GetUniqaSyncJobsService } from './get-uniqa-sync-jobs/get-uniqa-sync-jobs.service';
import { GetUniqaSyncJobByIdService } from './get-uniqa-sync-job-by-id/get-uniqa-sync-job-by-id.service';
import { RescheduleUniqaSyncJobService } from './reschedule-uniqa-sync-job/reschedule-uniqa-sync-job.service';
import { GetUniqaSyncJobAuditService } from './get-uniqa-sync-job-audit/get-uniqa-sync-job-audit.service';

@NgModule({
  providers: [
    GetUniqaSyncJobsService,
    GetUniqaSyncJobByIdService,
    RescheduleUniqaSyncJobService,
    GetUniqaSyncJobAuditService,
  ],
})
export class UniqaSyncJobsModule {}
